// Use dynamic import to avoid SSR issues with Next.js and to reduce bundle size
export async function loadMixpanel() {
  const mp = await import('mixpanel-browser')
  return mp.default || mp
}

const projectTokens: Record<string, string> = {
  sandbox: 'a06155a3533aa53b096a9448a4780f39',
  prod: 'a06155a3533aa53b096a9448a4780f39',
}

export function shouldUseMixpanel(): boolean {
  // Simple heuristic – enable in production but allow overriding via env var
  if (typeof window === 'undefined') {
    return false
  }
  const disabled = (window as unknown as { NUGLE_TRACK_TO_LOGGER?: boolean })?.NUGLE_TRACK_TO_LOGGER === true
  return !disabled
}

export async function newMixpanel(): Promise<unknown> {
  const mixpanel = await loadMixpanel()
  const project: 'sandbox' | 'prod' = 'sandbox'
  const token = projectTokens[project]
  ;(mixpanel as { init: (token: string, options: { debug: boolean }) => void }).init(token, { debug: false })
  return mixpanel
}
